import React from 'react'

const CheckCircle = () => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_178_47866)">
      <path
        d="M6.99984 1.28809C3.77984 1.28809 1.1665 3.90142 1.1665 7.12142C1.1665 10.3414 3.77984 12.9548 6.99984 12.9548C10.2198 12.9548 12.8332 10.3414 12.8332 7.12142C12.8332 3.90142 10.2198 1.28809 6.99984 1.28809ZM5.83317 10.0381L2.9165 7.12142L3.739 6.29892L5.83317 8.38725L10.2607 3.95975L11.0832 4.78809L5.83317 10.0381Z"
        fill="#669944"
      />
    </g>
    <defs>
      <clipPath id="clip0_178_47866">
        <rect
          width="14"
          height="14"
          fill="white"
          transform="translate(0 0.121582)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default CheckCircle
